import { render, staticRenderFns } from "./c-circle-badge.vue?vue&type=template&id=21cf474c&"
import script from "./c-circle-badge.vue?vue&type=script&lang=js&"
export * from "./c-circle-badge.vue?vue&type=script&lang=js&"
import style0 from "./c-circle-badge.vue?vue&type=style&index=0&id=21cf474c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports